module.exports = __webpack_public_path__ + "img/moduleYou.c451a4b4.png";